import moment from 'moment'

const formatDateFields = (params, format = 'M/D/YY') =>
  params.value
    ? moment(new Date(params.value)).format(format)
    : null

export default formatDateFields
